"use client";

import React from "react";
import { Check } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheInvestment() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = ["15-20 minute discovery call with Olivia, your AI voice agent", "Personalized report identifying where AI can save you time", "Fast delivery within 48 hours of your call", "Actionable insights with no tech background required"];
  return <section id="the-investment" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center min-h-[80vh]">
      <div className="w-full max-w-7xl mx-auto flex flex-col items-center">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold tracking-tight mb-4">
            The Assessment
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto font-sans">
            Contact us to discuss your custom assessment and investment.
          </p>
        </div>

        <div ref={ref} className={`w-full max-w-[800px] transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Card className="bg-gradient-to-b from-[#0A0A0A] to-[#050505] border-x-border/5 border-b-border/5 border-t-2 border-t-[#2D6A4F] shadow-2xl shadow-black/50 overflow-hidden rounded-xl">
            <CardHeader className="text-center pb-6 pt-12">
              <CardTitle className="text-2xl md:text-3xl font-default text-white/90 tracking-wide uppercase">
                AI Assessment
              </CardTitle>
              <CardDescription className="text-muted-foreground mt-3 text-base font-sans">
                Comprehensive analysis for businesses with 5-50 employees.
              </CardDescription>
            </CardHeader>
            
            <CardContent className="flex flex-col items-center px-6 sm:px-12 py-8">
              <div className="text-center mb-12">
                <p className="text-xl md:text-2xl font-sans text-white/90 leading-relaxed max-w-md">
                  Reach out to discuss your custom assessment and how RecoupTime delivers ROI for your business.
                </p>
              </div>

              <ul className="w-full max-w-lg space-y-5 text-left">
                {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                    <div className="mt-1 bg-[#2D6A4F]/10 rounded-md p-1 shrink-0">
                      <Check className="w-5 h-5 text-[#2D6A4F]" strokeWidth={3} />
                    </div>
                    <span className="text-foreground/80 text-lg font-sans leading-relaxed">
                      {feature}
                    </span>
                  </li>)}
              </ul>
            </CardContent>
            
            <CardFooter className="flex justify-center pb-12 pt-4 px-6 sm:px-12">
              <Link to="/ContactPage" className="w-full max-w-lg">
                <Button size="lg" className="w-full bg-[#2D6A4F] hover:bg-[#2D6A4F]/80 text-white text-lg h-16 rounded-md font-default font-semibold tracking-wide transition-colors duration-300 shadow-lg shadow-[#2D6A4F]/20">
                  Schedule a Consultation
                </Button>
              </Link>
            </CardFooter>
          </Card>
        </div>
      </div>
    </section>;
}